

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";


@Component({
  templateUrl: "./dialog-modifica-listino.component.html",
  styleUrls: ["../listino.component.css"],
})
export class ModificaListinoComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  protected aziende: Impresa[]      = [];
  protected aziendeConListino: Impresa[]      = [];
  public modificaListinoForm: FormGroup;
  protected listinoDaModificare:Listino;

  protected pagineModificaListino: MenuItem[];
  protected activeIndex: number = 0;
  
  protected isUpdatingListino:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
  ) {
    this.listinoDaModificare = this.config.data.listino;
    this.modificaListinoForm = this._formBuilder.group({
     // azienda:                    [null, [Validators.required]],
     /*  ita1:                       [this.listinoDaModificare.italia1, [Validators.required]],
      ita2:                       [this.listinoDaModificare.italia2, [Validators.required]],
      ita3:                       [this.listinoDaModificare.italia3, [Validators.required]],
      ita4:                       [this.listinoDaModificare.italia4, [Validators.required]],
      ita5:                       [this.listinoDaModificare.italia5, [Validators.required]], */
      preventivoBaseItalia:       [this.listinoDaModificare.preventivoBaseItalia, [Validators.required]],
      liguria1:                   [this.listinoDaModificare.liguria1],
      liguria2:                   [this.listinoDaModificare.liguria2],
      liguria3:                   [this.listinoDaModificare.liguria3],
      liguria4:                   [this.listinoDaModificare.liguria4],
      liguria5:                   [this.listinoDaModificare.liguria5],
      preventivoBaseLiguria:      [this.listinoDaModificare.preventivoBaseLiguria],
      piemonte1:                  [this.listinoDaModificare.piemonte1],
      piemonte2:                  [this.listinoDaModificare.piemonte2],
      piemonte3:                  [this.listinoDaModificare.piemonte3],
      piemonte4:                  [this.listinoDaModificare.piemonte4],
      piemonte5:                  [this.listinoDaModificare.piemonte5],
      preventivoBasePiemonte:     [this.listinoDaModificare.preventivoBasePiemonte],
      sardegna1:                  [this.listinoDaModificare.sardegna1],
      sardegna2:                  [this.listinoDaModificare.sardegna2],
      sardegna3:                  [this.listinoDaModificare.sardegna3],
      sardegna4:                  [this.listinoDaModificare.sardegna4],
      sardegna5:                  [this.listinoDaModificare.sardegna5],
      preventivoBaseSardegna:     [this.listinoDaModificare.preventivoBaseSardegna]
    });
  }

  ngOnInit(): void {
    
    this.modificaListinoForm.get('ita2')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.modificaListinoForm.get('ita3')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.modificaListinoForm.get('ita5')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());

    this.modificaListinoForm.get('liguria2')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());
    this.modificaListinoForm.get('liguria3')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());
    this.modificaListinoForm.get('liguria5')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());


    this.modificaListinoForm.get('piemonte2')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());
    this.modificaListinoForm.get('piemonte3')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());
    this.modificaListinoForm.get('piemonte5')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());

    this.modificaListinoForm.get('sardegna2')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
    this.modificaListinoForm.get('sardegna3')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
    this.modificaListinoForm.get('sardegna5')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
  
    this.inizializzaSteps();
  }

  inizializzaSteps() {
    this.pagineModificaListino = [
      {
        label: "Italia",
      },
      {
        label: "Liguria",
      },
      {
        label: "Piemonte",
      },
      {
        label: "Sardegna",
      }
    ];
    this.activeIndex = 0;
  }
  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineModificaListino.length - 1) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 0 && !this.modificaListinoForm.valid) {
      disableNextStepButton = true;
    }
    return disableNextStepButton;
  }
  changePage() {
    this.activeIndex = this.activeIndex + 1;
  
  }
  updatePreventivoBaseItalia() {
    const ita2 = this.modificaListinoForm.get('ita2')?.value || 0;
    const ita3 = this.modificaListinoForm.get('ita3')?.value || 0;
    const ita5 = this.modificaListinoForm.get('ita5')?.value || 0;
    this.modificaListinoForm.get('preventivoBaseItalia')?.setValue(ita2 + ita3 + ita5, { emitEvent: false });
  }
  updatePreventivoBaseLiguria() {
    const liguria2 = this.modificaListinoForm.get('liguria2')?.value || 0;
    const liguria3 = this.modificaListinoForm.get('liguria3')?.value || 0;
    const liguria5 = this.modificaListinoForm.get('liguria5')?.value || 0;
    this.modificaListinoForm.get('preventivoBaseLiguria')?.setValue(liguria2 + liguria3 + liguria5, { emitEvent: false });
  }
  updatePreventivoBasePiemonte() {
    const piemonte2 = this.modificaListinoForm.get('piemonte2')?.value || 0;
    const piemonte3 = this.modificaListinoForm.get('piemonte3')?.value || 0;
    const piemonte5 = this.modificaListinoForm.get('piemonte5')?.value || 0;
    this.modificaListinoForm.get('preventivoBasePiemonte')?.setValue(piemonte2 + piemonte3 + piemonte5, { emitEvent: false });
  }
  updatePreventivoBaseSardegna() {
    const sardegna2 = this.modificaListinoForm.get('sardegna2')?.value || 0;
    const sardegna3 = this.modificaListinoForm.get('sardegna3')?.value || 0;
    const sardegna5 = this.modificaListinoForm.get('sardegna5')?.value || 0;
    this.modificaListinoForm.get('preventivoBaseSardegna')?.setValue(sardegna2 + sardegna3 + sardegna5, { emitEvent: false });
  }

  
  isFormValorizzato(formGroup: FormGroup): boolean {
    return Object.values(formGroup.value).some(value => value !== null && value !== undefined && value !== '');
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isUpdatingListino = true;
     /*  this.listinoDaModificare.italia1               = this.modificaListinoForm.value.ita1;
      this.listinoDaModificare.italia2               = this.modificaListinoForm.value.ita2;
      this.listinoDaModificare.italia3               = this.modificaListinoForm.value.ita3;
      this.listinoDaModificare.italia4               = this.modificaListinoForm.value.ita4;
      this.listinoDaModificare.italia5               = this.modificaListinoForm.value.ita5; 
      this.listinoDaModificare.preventivoBaseItalia  = this.modificaListinoForm.value.preventivoBaseItalia;*/

        this.listinoDaModificare.liguria1               = this.modificaListinoForm.value.liguria1;
        this.listinoDaModificare.liguria2               = this.modificaListinoForm.value.liguria2;
        this.listinoDaModificare.liguria3               = this.modificaListinoForm.value.liguria3;
        this.listinoDaModificare.liguria4               = this.modificaListinoForm.value.liguria4;
        this.listinoDaModificare.liguria5               = this.modificaListinoForm.value.liguria5;
        this.listinoDaModificare.preventivoBaseLiguria  = this.modificaListinoForm.value.preventivoBaseLiguria;
       
        this.listinoDaModificare.piemonte1               = this.modificaListinoForm.value.piemonte1;
        this.listinoDaModificare.piemonte2               = this.modificaListinoForm.value.piemonte2;
        this.listinoDaModificare.piemonte3               = this.modificaListinoForm.value.piemonte3;
        this.listinoDaModificare.piemonte4               = this.modificaListinoForm.value.piemonte4;
        this.listinoDaModificare.piemonte5               = this.modificaListinoForm.value.piemonte5;
        this.listinoDaModificare.preventivoBasePiemonte  = this.modificaListinoForm.value.preventivoBasePiemonte;

        this.listinoDaModificare.sardegna1               = this.modificaListinoForm.value.sardegna1;
        this.listinoDaModificare.sardegna2               = this.modificaListinoForm.value.sardegna2;
        this.listinoDaModificare.sardegna3               = this.modificaListinoForm.value.sardegna3;
        this.listinoDaModificare.sardegna4               = this.modificaListinoForm.value.sardegna4;
        this.listinoDaModificare.sardegna5               = this.modificaListinoForm.value.sardegna5;
        this.listinoDaModificare.preventivoBaseSardegna  = this.modificaListinoForm.value.preventivoBaseSardegna;
       

       this.listiniService.modifica(this.listinoDaModificare).subscribe( {
        next: (resCreaProgetto) => {
          this.isUpdatingListino = false;
          this.dialogRef.close({ success: true });
        },
        error: (e) => {
            this.isUpdatingListino = false;
            this.logger.error(e);
            this.dialogRef.close({ success: false });
            this.messageService.add({
              severity: "error",
              summary: "ATTENZIONE",
              detail: "Errore in fase di modifica del listino!", life:10000
            });
      },
        complete: () => {

          //this.isLoadingResults = false;
        }
    }); 
    }
  }
}
